import { useQuery } from "@tanstack/react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import api from "../lib/api.js";
import { smartDate } from "../lib/dates.js";

export default function AlertsPage() {
  const { data: notifications = [], isLoading } = useQuery({
    queryKey: ["notifications"],
    queryFn: () => api.get("notifications").json(),
  });

  if (isLoading) return <div className="p-6 data text-sm" style={{ color: "var(--color-muted)" }}>Loading…</div>;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-xl font-semibold data" style={{ color: "var(--color-white)" }}>Alerts</h1>
        <p className="data text-xs mt-1" style={{ color: "var(--color-muted)" }}>Rave detection notifications</p>
      </div>

      {notifications.length === 0 ? (
        <div className="card p-12 text-center data text-sm" style={{ color: "var(--color-muted)" }}>
          No alerts yet
        </div>
      ) : (
        <div className="space-y-2">
          {notifications.map((n) => (
            <div key={n.id} className="card p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    {n.device_name && (
                      <span className="data text-xs font-semibold" style={{ color: "var(--color-cyan)" }}>
                        {n.device_name}
                      </span>
                    )}
                    {n.sms_also_sent && (
                      <span className="data text-xs flex items-center gap-1" style={{
                        color: "var(--color-blue)",
                        border: "1px solid rgba(68,136,255,0.3)",
                        borderRadius: 4, padding: "1px 6px",
                        fontFamily: "var(--font-mono)", letterSpacing: "0.06em",
                      }}>
                        <FontAwesomeIcon icon={faMobileScreen} style={{ fontSize: 10 }} /> SMS sent
                      </span>
                    )}
                  </div>
                  <div className="data text-sm" style={{ color: "var(--color-white)", whiteSpace: "pre-line" }}>{n.message_body}</div>
                </div>
                <div className="data text-xs flex-shrink-0" style={{ color: "var(--color-muted)" }}>
                  {n.sent_at ? smartDate(n.sent_at) : "—"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
